import { IntersectingCountyNodeFields } from '../../generated/graphql';
import { InternalLink } from '../Clickables/InternalLink/InternalLink';
import { getRegionUrl } from '@domain/routes/urls';
import { firstNonEmpty } from '@lib/strings/firstNonEmpty';
import { getUniqueCountiesByRegion } from './helpers/getUniqueCountiesByRegion';
import ReactAnd from 'react-and';

interface IProps {
  regionId?: string | null;
  regionName?: string | null;
  countyName?: string;
  intersectingCounties: IntersectingCountyNodeFields[];
}

export const IntersectingCountiesLinks = ({
  regionId,
  regionName,
  countyName,
  intersectingCounties,
}: IProps) => {
  if (!regionId || !regionName || !countyName) {
    return null;
  }

  const uniqueCountiesByRegion = getUniqueCountiesByRegion(
    countyName,
    regionId,
    intersectingCounties,
  );

  if (uniqueCountiesByRegion.length === 0) {
    return null;
  }

  return (
    <span data-testid="intersecting-counties-links">
      {`It is also intersecting with `}
      <ReactAnd>
        {uniqueCountiesByRegion.flatMap(({ name, region, country }) => {
          if (!region.regionCode || !region.name || !name) {
            return [];
          }
          const regionDisplayName = firstNonEmpty(region.localName, region.name);
          return (
            <span key={`cr-${name}-${region.regionCode}`}>
              {`${name}, `}
              <InternalLink
                to={getRegionUrl(country.id, region.regionCode, country.countryName, region.name)}
                className="text-primary"
              >
                {regionDisplayName}
              </InternalLink>
            </span>
          );
        })}
      </ReactAnd>
      {`. `}
    </span>
  );
};
